import { createFileRoute } from "@tanstack/react-router";
import DocsPage from "../docs/DocsPage";

export const Route = createFileRoute("/docs")({ component: DocsPage });
